import Axios from "axios";
/* eslint-disable */
export default {
  name: 'contact-modal',
  components: {},
  props: {},
  data() {
    return {
      name: "",
      email: "",
      message: "",
      isLoading: false,
      success: false,
      error: false,
      errormsg: ""
    }
  },
  computed: {
    contactModal() {
      return this.$store.state.contactModal
    },
  },
  mounted() {

  },
  methods: {
    hideModal: function () {
      this.$store.commit("SET_CONTACTMODAL", false);
      this.name = this.email = this.message = this.errormsg = "";
      this.isLoading = this.success = this.error = false;
    },
    submit: function () {
      var that = this;
      this.isLoading = true;
      var formdata = new FormData();
      formdata.set('name', this.name);
      formdata.set('email', this.email);
      formdata.set('message', this.message);

      Axios({
          method: 'post',
          url: 'https://crm.origin.berlin/submit.php',
          data: formdata,
          config: {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        })
        .then(function (response) {
          that.isLoading = false;
          if (response.data.status == "ok") {
            that.success = true;
            that.error = false;

            that.$gtm.trackEvent({
              event: "lead", // Event type [default = 'interaction'] (Optional)
              category: 'modal',
              action: 'contact',
              noninteraction: false // Optional
            });

          } else {
            that.error = true;
            that.errormsg = response.data.message
          }
        })
        .catch(function (error) {
          console.log(error)
          that.isLoading = false;
        });
    }
  }
}